import { memo, useCallback } from 'react';
import Select from '@/components/Select.jsx';
import getValue from '@/lib/getValue.js';

const conjunctionOptions = [
  { label: 'And', value: 'and' },
  { label: 'Or', value: 'or' }
];

const FilterConjunction = memo(({ item, filter, index, isAdvanced = false, onChange }) => {
  const conjunction = getValue(conjunctionOptions, item?.conjunction) || 'And';

  const handleConjunctionChange = useCallback(
    ({ value }) => {
      onChange(filter?.id, value);
    },
    [onChange, filter?.id]
  );

  return (
    <>
      {index === 0 && <span className="conjunction">If</span>}
      {index > 0 && !isAdvanced && <span className="conjunction">And</span>}
      {index === 1 && isAdvanced && (
        <Select //
          compact
          size="sm"
          className="conjunction-select"
          options={conjunctionOptions}
          value={getValue(conjunctionOptions, item?.conjunction)}
          onChange={handleConjunctionChange}
        />
      )}
      {index > 1 && isAdvanced && <span className="conjunction">{conjunction}</span>}
    </>
  );
});

FilterConjunction.displayName = 'FilterConjunction';

export default FilterConjunction;
